
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("hBXeM", function(module, exports) {
$parcel$export(module.exports, "default", () => $93cba96ff6c2b633$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $75gsN = parcelRequire("75gsN");

var $dihY4 = parcelRequire("dihY4");

var $g3vc1 = parcelRequire("g3vc1");

var $1ZAEl = parcelRequire("1ZAEl");

var $45OtX = parcelRequire("45OtX");
const $93cba96ff6c2b633$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $bSJIT.useEffect)(()=>{
        if (!emojiId) return;
        (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $g3vc1.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $dihY4.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $45OtX.UfoErrorBoundary), {
        experiences: [
            (0, $dihY4.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1ZAEl.ResourcedEmojiComponent), props));
};
var $93cba96ff6c2b633$export$2e2bcd8739ae039 = $93cba96ff6c2b633$var$ResourcedEmoji;

});
parcelRegister("75gsN", function(module, exports) {
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $69a811143c3eb922$export$71c8cba6f1251ea9);

var $dihY4 = parcelRequire("dihY4");

var $hfMr4 = parcelRequire("hfMr4");
const $69a811143c3eb922$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $hfMr4.withSampling)((0, $dihY4.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};

});

parcelRegister("1ZAEl", function(module, exports) {
$parcel$export(module.exports, "ResourcedEmojiComponent", () => $6ea68613b54f7b59$export$7bfde52eceb3e2f6);
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $4VhyM = parcelRequire("4VhyM");

var $5nwBg = parcelRequire("5nwBg");

var $2u9sW = parcelRequire("2u9sW");

var $75gsN = parcelRequire("75gsN");

var $g3vc1 = parcelRequire("g3vc1");

var $61jKi = parcelRequire("61jKi");

var $hSdEI = parcelRequire("hSdEI");

var $2D4MI = parcelRequire("2D4MI");

var $8MOlQ = parcelRequire("8MOlQ");

var $7hbMQ = parcelRequire("7hbMQ");
const $6ea68613b54f7b59$var$ignoreWrapperStyles = null;
var $6ea68613b54f7b59$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($6ea68613b54f7b59$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $6ea68613b54f7b59$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, emojiProviderLookupOrder: emojiProviderLookupOrder, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $g3vc1.defaultEmojiHeight), ignoreWrapper: ignoreWrapper = false, optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, pageTitleEmoji: pageTitleEmoji = false, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $bSJIT.useState)();
    const [loaded, setLoaded] = (0, $bSJIT.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $bSJIT.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $bSJIT.useState)();
    const fetchOrGetEmoji = (0, $bSJIT.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch, (0, $gdUUy.fg)('platform_bitbucket_fix_shortname_and_ordering') ? emojiProviderLookupOrder : undefined);
        (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).mark((0, $5nwBg.UfoEmojiTimings).METADATA_START);
        if ((0, $2D4MI.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                    // emoji is undefined
                    (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).mark((0, $5nwBg.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).mark((0, $5nwBg.UfoEmojiTimings).METADATA_END);
        }
    }, [
        emojiProviderLookupOrder,
        onEmojiLoadFail
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $2u9sW.hasUfoMarked)((0, $75gsN.sampledUfoRenderedEmoji)(emojiId), (0, $5nwBg.UfoEmojiTimings).FMP_END)) (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    // Fetching during render means a render React later discards (for example a pass that suspends)
    // still creates a promise whose callbacks set state and schedule yet another render. This layout
    // effect only runs for committed renders, and being pre-paint it keeps the synchronous cache-hit
    // path from flashing the placeholder.
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
   * Setting resolved emoji provider for optimistic rendering
   */ (0, $bSJIT.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $bSJIT.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $bSJIT.useMemo)(()=>{
        // reduce blast radius by targeting page title
        if (pageTitleEmoji && optimisticImageURL && (0, $gdUUy.fg)('platform_emoji_prevent_img_src_changing')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $g3vc1.defaultEmojiHeight),
                width: fitToHeight || (0, $g3vc1.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        // extend prevention to all surfaces
        if (optimisticImageURL && (0, $gdUUy.fg)('platform_emoji_prevent_img_src_changing_all')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $g3vc1.defaultEmojiHeight),
                width: fitToHeight || (0, $g3vc1.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        if (optimisticImageURL) {
            if (emoji && ((0, $61jKi.isImageRepresentation)(emoji.representation) || (0, $hSdEI.isMediaRepresentation)(emoji === null || emoji === void 0 ? void 0 : emoji.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $g3vc1.defaultEmojiHeight),
                    width: fitToHeight || (0, $g3vc1.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName,
        pageTitleEmoji
    ]);
    const handleOnLoadError = (0, $bSJIT.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $75gsN.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $bSJIT.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]);
    // use width: auto when fitToHeight is defined
    const autoWidth = !!fitToHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4VhyM.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        "data-ssr-placeholder": `emoji-${id ?? shortName}`,
        "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
        className: (0, $9fU1q.default)([
            ignoreWrapper && "_1e0c1bgi"
        ])
    }, emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7hbMQ.default), {
        shortName: shortName,
        showTooltip: showTooltip,
        size: fitToHeight || (0, $g3vc1.defaultEmojiHeight),
        loading: true,
        xcss: placeholderXcss
    }), emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, customFallback || fallback || shortName), emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8MOlQ.default), {
        emoji: optimisticEmojiDescription,
        onLoadError: handleOnLoadError,
        onLoadSuccess: handleOnLoadSuccess,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        autoWidth: autoWidth,
        editorEmoji: editorEmoji
    })));
};
var $6ea68613b54f7b59$export$2e2bcd8739ae039 = $6ea68613b54f7b59$export$7bfde52eceb3e2f6;

});
parcelRegister("4VhyM", function(module, exports) {
$parcel$export(module.exports, "EmojiCommonProvider", () => $52bb1523ad98b8aa$export$1120e666998e21b5);

var $bSJIT = parcelRequire("bSJIT");

var $eirVz = parcelRequire("eirVz");
const $52bb1523ad98b8aa$export$1120e666998e21b5 = (props)=>{
    const emojiContextValue = (0, $bSJIT.useMemo)(()=>props.emojiProvider ? {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        } : undefined, [
        props.emojiProvider
    ]);
    if (!!emojiContextValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eirVz.EmojiContextProvider), {
        emojiContextValue: emojiContextValue
    }, props.children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, props.children);
};

});
parcelRegister("eirVz", function(module, exports) {
$parcel$export(module.exports, "EmojiContextProvider", () => $9c1f86033ffab0b1$export$f4a09143833145ed);

var $bSJIT = parcelRequire("bSJIT");

var $cz2rC = parcelRequire("cz2rC");

var $1Hsl1 = parcelRequire("1Hsl1");
const $9c1f86033ffab0b1$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $bSJIT.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await (memoizedEmojiContextValue === null || memoizedEmojiContextValue === void 0 ? void 0 : memoizedEmojiContextValue.emoji.emojiProvider.fetchEmojiProvider());
            } catch (error) {
                (0, $cz2rC.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue !== null && memoizedEmojiContextValue !== void 0 && memoizedEmojiContextValue.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue === null || memoizedEmojiContextValue === void 0 ? void 0 : memoizedEmojiContextValue.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1Hsl1.EmojiContext).Provider, {
        value: memoizedEmojiContextValue
    }, children);
};

});
parcelRegister("1Hsl1", function(module, exports) {
$parcel$export(module.exports, "EmojiContext", () => $81776840f1306ab1$export$9fab6c37a453c65e);

var $bSJIT = parcelRequire("bSJIT");
const $81776840f1306ab1$export$9fab6c37a453c65e = (0, $bSJIT.createContext)(null);

});



parcelRegister("2u9sW", function(module, exports) {
$parcel$export(module.exports, "hasUfoMarked", () => $8b85a9e627fbc1bb$export$a9be054d2a5cedc0);
const $8b85a9e627fbc1bb$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};

});

parcelRegister("8MOlQ", function(module, exports) {
$parcel$export(module.exports, "EmojiNodeWrapper", () => $8acb4eae47367b1d$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $8acb4eae47367b1d$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $5N1Y4 = parcelRequire("5N1Y4");

var $lavtv = parcelRequire("lavtv");

var $5nwBg = parcelRequire("5nwBg");

var $2u9sW = parcelRequire("2u9sW");

var $75gsN = parcelRequire("75gsN");

var $dihY4 = parcelRequire("dihY4");

var $i7XuO = parcelRequire("i7XuO");

var $g3vc1 = parcelRequire("g3vc1");

var $cT3ZI = parcelRequire("cT3ZI");

var $hQiBh = parcelRequire("hQiBh");

var $aR8hx = parcelRequire("aR8hx");

var $6HPhi = parcelRequire("6HPhi");

var $6flhL = parcelRequire("6flhL");

var $kSCIg = parcelRequire("kSCIg");

var $7JH3u = parcelRequire("7JH3u");
const $8acb4eae47367b1d$var$emojiSpriteContainer = null;
const $8acb4eae47367b1d$var$emojiImageContainer = null;
const $8acb4eae47367b1d$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $g3vc1.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $hQiBh.leftClick)(event)) {
        if (props.preventFocusOnMouseDown) event.preventDefault();
        onSelected((0, $aR8hx.toEmojiId)(emoji), emoji, event);
    }
};
const $8acb4eae47367b1d$var$handleKeyDown = (props, event)=>{
    if (!(0, $g3vc1.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $g3vc1.KeyboardKeys).Enter || event.key === (0, $g3vc1.KeyboardKeys).Space)) onSelected((0, $aR8hx.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $g3vc1.KeyboardKeys).Backspace) (0, $6flhL.handleDelete)(props, event);
};
const $8acb4eae47367b1d$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $aR8hx.toEmojiId)(emoji), emoji, event);
};
const $8acb4eae47367b1d$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $aR8hx.toEmojiId)(emoji), emoji, event);
};
const $8acb4eae47367b1d$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, isDecorative: isDecorative, ...other } = props;
    const intl = (0, $bSJIT.useContext)((0, $fK3tS.Context));
    const isAriaLabelEmpty = editorEmoji || isDecorative;
    let ariaLabel;
    if (isAriaLabelEmpty) ariaLabel = undefined;
    else if (intl) ariaLabel = intl.formatMessage((0, $6HPhi.messages).changeEmojiShortnameButtonLabel, {
        shortName: emoji.name ?? emoji.shortName
    });
    else ariaLabel = emoji.shortName;
    const tooltipContent = showTooltip && (0, $5N1Y4.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName || emoji.name || undefined : undefined;
    const emojiSpan = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        role: editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation',
        "aria-label": ariaLabel,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50g2xd _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j1dpa _3naf1dpa _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc" : "_2rkofajl _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk1j28 _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j1dpa _3naf1dpa _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc",
            className
        ]),
        onKeyDown: (event)=>$8acb4eae47367b1d$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $8acb4eae47367b1d$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $8acb4eae47367b1d$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $8acb4eae47367b1d$var$handleFocus(props, event);
        },
        title: showTooltip && !(0, $5N1Y4.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName : undefined,
        ...other
    }, children);
    if (tooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: tooltipContent,
        isScreenReaderAnnouncementDisabled: true,
        position: "top",
        tag: "span"
    }, emojiSpan);
    return emojiSpan;
});
const $8acb4eae47367b1d$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $i7XuO.useSampledUFOComponentExperience)((0, $dihY4.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $g3vc1.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $bSJIT.useEffect)(()=>{
        const ufoExp = (0, $75gsN.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $2u9sW.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $2u9sW.hasUfoMarked)(ufoExp, (0, $5nwBg.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $5nwBg.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $cT3ZI.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7JH3u.SpriteEmoji), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kSCIg.ImageEmoji), props);
};
var $8acb4eae47367b1d$export$2e2bcd8739ae039 = $8acb4eae47367b1d$export$56cc48506ff790a;

});
parcelRegister("i7XuO", function(module, exports) {
$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $06df99f239b6dec9$export$f959821a7419dee1);

var $bSJIT = parcelRequire("bSJIT");

var $hfMr4 = parcelRequire("hfMr4");
const $06df99f239b6dec9$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $bSJIT.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $06df99f239b6dec9$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            (0, $hfMr4.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $06df99f239b6dec9$var$useConstructor(()=>{
        (0, $hfMr4.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("cT3ZI", function(module, exports) {
$parcel$export(module.exports, "isSpriteRepresentation", () => $44db77f14bf4c329$export$a194199d673d75de);
const $44db77f14bf4c329$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);

});

parcelRegister("hQiBh", function(module, exports) {
$parcel$export(module.exports, "leftClick", () => $beb596bf0be919cc$export$34ebdaf2c517ae75);
function $beb596bf0be919cc$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("6HPhi", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7fb87804b328f39c$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $7fb87804b328f39c$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Heading text shown at the top of the emoji removal confirmation dialog, prompting the user to confirm removing the selected custom emoji.'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Body text shown inside the emoji removal confirmation dialog. The placeholder {emojiShortName} will be substituted with the short name (e.g. ":smile:") of the replacement emoji.'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Label for the primary action button in the emoji removal confirmation dialog that confirms and executes the removal.'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Label for the button in the emoji picker that opens the custom emoji upload panel, allowing users to add their own emoji.'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiNameLabel: {
        id: 'fabric.emoji.name.label',
        defaultMessage: 'Emoji name',
        description: 'Label for the emoji name input field in the custom emoji upload panel'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Label for the file chooser button in the custom emoji upload panel where users select an image file for their emoji.'
    },
    emojiChooseFileDndTitle: {
        id: 'fabric.emoji.choose.file.dnd.title',
        defaultMessage: 'Select or drop an image',
        description: 'Label for the file chooser button in the custom emoji upload panel where users select or drag and drop an image file for their emoji.'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectColorButtonAriaLabelText: {
        id: 'fabric.emoji.select.color.ariaLabel',
        defaultMessage: 'Productivity emoji color selector',
        description: 'Message indicating the purpose of the color selection button and the selected color'
    },
    emojiSelectColorListAriaLabelText: {
        id: 'fabric.emoji.select.color.list.ariaLabel',
        defaultMessage: 'Productivity emoji colour selector',
        description: 'Message indicating the purpose of the productivity emoji color list selector'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Section heading shown above the emoji preview area in the custom emoji upload panel.'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Success text shown in the emoji preview area after the user uploads a new emoji image. The placeholder {emoji} will be substituted with the rendered emoji image.'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'Label for the submit button in the custom emoji upload panel that saves the new emoji to the workspace.'
    },
    createEmojiWithRovoTitle: {
        id: 'fabric.emoji.ai.create.title',
        defaultMessage: 'Create an emoji with Rovo',
        description: 'Section heading for the AI emoji generation area where users describe an emoji and generate it with AI.'
    },
    createEmojiWithRovoPromptPlaceholder: {
        id: 'fabric.emoji.ai.prompt.placeholder',
        defaultMessage: 'Describe your emoji...',
        description: 'Placeholder text for the input where the user describes the emoji they want the AI to generate.'
    },
    createEmojiWithRovoPromptAriaLabel: {
        id: 'fabric.emoji.ai.prompt.ariaLabel',
        defaultMessage: 'Describe the emoji you want to generate',
        description: 'Accessible label for the AI emoji description input field.'
    },
    createEmojiWithRovoGenerateLabel: {
        id: 'fabric.emoji.ai.generate.label',
        defaultMessage: 'Generate',
        description: 'Label for the button that triggers AI generation of the described emoji.'
    },
    createEmojiWithRovoError: {
        id: 'fabric.emoji.ai.error',
        defaultMessage: 'Something went wrong. Try a different description.',
        description: 'Inline error message shown when AI emoji generation or upload fails, prompting the user to try again.'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'Label for the button in the custom emoji upload panel that retries a previously failed upload attempt.'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'Label for the cancel button in the custom emoji upload panel that dismisses the panel without saving.'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text shown inside the emoji search input field in the emoji picker before the user types a query.'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'Accessible label for the emoji name search input field in the emoji picker, used by screen readers.'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Category heading label shown in the emoji picker category bar when displaying results from a search query.'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Label for the Frequent category tab in the emoji picker, showing recently used emojis.'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Label for the People category tab in the emoji picker, showing face and person emojis.'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Label for the Nature category tab in the emoji picker, showing animal and nature emojis.'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Label for the Food and Drink category tab in the emoji picker.'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Label for the Activity category tab in the emoji picker, showing sports and activity emojis.'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Label for the Travel and Places category tab in the emoji picker, showing location and travel emojis.'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Label for the Objects category tab in the emoji picker, showing everyday object emojis.'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Label for the Symbols category tab in the emoji picker, showing symbol and sign emojis.'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Label for the Flags category tab in the emoji picker, showing country and regional flag emojis.'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Label for the Atlassian and productivity category tab in the emoji picker, showing Atlassian product and productivity emojis.'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'Label for the Your Uploads category tab in the emoji picker, showing custom emojis uploaded by the current user.'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'Label for the All Uploads category tab in the emoji picker, showing all custom emojis uploaded across the workspace.'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Error message shown in the custom emoji upload panel when the image upload fails due to an error.'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Error message shown in the custom emoji upload panel when the image upload fails because it timed out.'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiUnsupportedFileType: {
        id: 'fabric.emoji.error.unsupported.file.type',
        defaultMessage: "This file type isn't supported. Select a PNG, JPEG, or GIF to create your emoji.",
        description: 'Error message shown when the selected emoji upload file type is not supported'
    },
    emojiDuplicateName: {
        id: 'fabric.emoji.error.duplicate.name',
        defaultMessage: 'An emoji with this name exists already',
        description: 'Error message shown when the user tries to upload an emoji with a name that already exists in the custom emoji set'
    },
    emojiPickerNoResults: {
        id: 'fabric.emoji.picker.no.results',
        defaultMessage: 'No results',
        description: 'Heading shown in the emoji picker when a search query returns no matching emojis.'
    },
    emojiPickerAddCustomEmoji: {
        id: 'fabric.emoji.picker.add.custom.emoji',
        defaultMessage: 'Add custom emoji',
        description: 'Label for the button shown in the emoji picker no-results screen that opens the custom emoji upload panel.'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Accessible aria-label for the emoji picker dialog, used by screen readers to identify the picker.'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    changeEmojiShortnameButtonLabel: {
        id: 'fabric.emoji.change.shortname.button.label',
        defaultMessage: 'Change emoji, currently {shortName}',
        description: 'Aria label for the button in page title used to change emoji'
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});

parcelRegister("6flhL", function(module, exports) {
$parcel$export(module.exports, "handleDelete", () => $683a7c5fe3f7a9e3$export$471c4c6c1d1a0512);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $aR8hx = parcelRequire("aR8hx");
const $683a7c5fe3f7a9e3$export$471c4c6c1d1a0512 = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $aR8hx.toEmojiId)(emoji), emoji, event);
};

});

parcelRegister("kSCIg", function(module, exports) {
$parcel$export(module.exports, "ImageEmoji", () => $a63a2e5511478388$export$99dfeb9d71c11788);
/* ImageEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $c9wRy = parcelRequire("c9wRy");

var $lavtv = parcelRequire("lavtv");

var $7nHRn = parcelRequire("7nHRn");

var $7mkqx = parcelRequire("7mkqx");

var $5nwBg = parcelRequire("5nwBg");

var $2u9sW = parcelRequire("2u9sW");

var $75gsN = parcelRequire("75gsN");

var $cX08X = parcelRequire("cX08X");

var $61jKi = parcelRequire("61jKi");

var $hSdEI = parcelRequire("hSdEI");

var $aR8hx = parcelRequire("aR8hx");

var $aYVZJ = parcelRequire("aYVZJ");

var $a0KSx = parcelRequire("a0KSx");

var $3pBZT = parcelRequire("3pBZT");

var $8MOlQ = parcelRequire("8MOlQ");

var $6flhL = parcelRequire("6flhL");

var $55FVI = parcelRequire("55FVI");
const $a63a2e5511478388$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $aR8hx.toEmojiId)(emoji), emoji, event);
};
const $a63a2e5511478388$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, isDecorative: isDecorative } = props;
    const [ref, inView] = (0, $7mkqx.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $bSJIT.useMemo)(()=>(0, $75gsN.sampledUfoRenderedEmoji)(emoji), [
        emoji
    ]);
    const classes = `${(0, $55FVI.emojiMainStyle)} ${(0, $55FVI.emojiNodeStyles)} ${selected ? (0, $55FVI.commonSelectedStyles) : ''} ${selectOnHover ? (0, $55FVI.selectOnHoverStyles) : ''} ${(0, $55FVI.emojiImage)} ${className ? className : ''} ${showDelete ? (0, $55FVI.deletableEmoji) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $7nHRn.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $61jKi.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $hSdEI.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) {
        const sizingWidth = autoWidth ? 'auto' : fitToHeight / height * width;
        // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: sizingWidth,
            height: fitToHeight
        };
    }
    const onError = (0, $bSJIT.useCallback)((event)=>{
        $a63a2e5511478388$var$handleImageError({
            emoji: props.emoji,
            onLoadError: props.onLoadError
        }, event);
    }, [
        props.emoji,
        props.onLoadError
    ]);
    const onLoad = (0, $bSJIT.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $5nwBg.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $2u9sW.hasUfoMarked)(ufoExp, (0, $5nwBg.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $5nwBg.UfoEmojiTimings).ONLOAD_START, mountedMark === null || mountedMark === void 0 ? void 0 : mountedMark.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $5nwBg.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $2u9sW.hasUfoMarked)(ufoExp, (0, $5nwBg.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $5nwBg.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $cX08X.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $bSJIT.useCallback)(()=>{
        if (!(0, $2u9sW.hasUfoMarked)(ufoExp, (0, $5nwBg.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $5nwBg.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $bSJIT.useCallback)((e)=>{
        var _getDocument;
        // only disable tooltip when not on focus
        if (!((_getDocument = (0, $c9wRy.getDocument)()) !== null && _getDocument !== void 0 && (_getDocument = _getDocument.activeElement) !== null && _getDocument !== void 0 && _getDocument.contains(e.target))) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $bSJIT.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const imgAlt = isDecorative ? '' : emoji.name || emoji.shortName || '';
    const emojiNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        key: src,
        alt: imgAlt,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    });
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aYVZJ.DeletableEmojiTooltipContent), null),
        position: "right-start",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8MOlQ.EmojiNodeWrapper), {
        ...props,
        "aria-labelledby": `screenreader-emoji-${emoji.id}`,
        type: "image",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classes,
        ref: ref,
        showTooltip: false,
        onMouseOver: onMouseOver
    }, emojiNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3pBZT.default), {
        onClick: (event)=>(0, $6flhL.handleDelete)(props, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $a0KSx.DeletableEmojiTooltipContentForScreenReader), {
        emoji: emoji
    })));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8MOlQ.EmojiNodeWrapper), {
        ...props,
        type: "image",
        className: classes,
        ref: ref
    }, emojiNode));
};

});
parcelRegister("7nHRn", function(module, exports) {
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $879a040fe58217fa$export$b7e9058f156d8d19);

var $3QKqR = parcelRequire("3QKqR");
const $879a040fe58217fa$var$getHeight = (fitToHeight)=>(0, $3QKqR.getPixelRatio)() > 1 ? fitToHeight * 2 : fitToHeight;
const $879a040fe58217fa$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && emoji.representation && 'height' in emoji.representation && $879a040fe58217fa$var$getHeight(fitToHeight) > emoji.representation.height);

});

parcelRegister("7mkqx", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $cb9dcb8197c4926e$export$2f62ee6831462844);

var $jlZNl = parcelRequire("jlZNl");

var $cX08X = parcelRequire("cX08X");
const $cb9dcb8197c4926e$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $jlZNl.useInView)(options);
    if (!(0, $cX08X.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("jlZNl", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $e16fe9ae426e49d9$export$2f62ee6831462844);

var $bSJIT = parcelRequire("bSJIT");
"use client";
var $e16fe9ae426e49d9$var$__defProp = Object.defineProperty;
var $e16fe9ae426e49d9$var$__defNormalProp = (obj, key, value)=>key in obj ? $e16fe9ae426e49d9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e16fe9ae426e49d9$var$__publicField = (obj, key, value)=>$e16fe9ae426e49d9$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $e16fe9ae426e49d9$var$observerMap = /* @__PURE__ */ new Map();
var $e16fe9ae426e49d9$var$RootIds = /* @__PURE__ */ new WeakMap();
var $e16fe9ae426e49d9$var$rootId = 0;
var $e16fe9ae426e49d9$var$unsupportedValue = void 0;
function $e16fe9ae426e49d9$export$2ef3a60ee1f37bec(inView) {
    $e16fe9ae426e49d9$var$unsupportedValue = inView;
}
function $e16fe9ae426e49d9$var$getRootId(root) {
    if (!root) return "0";
    if ($e16fe9ae426e49d9$var$RootIds.has(root)) return $e16fe9ae426e49d9$var$RootIds.get(root);
    $e16fe9ae426e49d9$var$rootId += 1;
    $e16fe9ae426e49d9$var$RootIds.set(root, $e16fe9ae426e49d9$var$rootId.toString());
    return $e16fe9ae426e49d9$var$RootIds.get(root);
}
function $e16fe9ae426e49d9$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $e16fe9ae426e49d9$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $e16fe9ae426e49d9$var$createObserver(options) {
    const id = $e16fe9ae426e49d9$var$optionsToId(options);
    let instance = $e16fe9ae426e49d9$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $e16fe9ae426e49d9$var$observerMap.set(id, instance);
    }
    return instance;
}
function $e16fe9ae426e49d9$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $e16fe9ae426e49d9$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $e16fe9ae426e49d9$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $e16fe9ae426e49d9$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $e16fe9ae426e49d9$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $e16fe9ae426e49d9$export$a62107ca74432f44 = class extends $bSJIT.Component {
    constructor(props){
        super(props);
        $e16fe9ae426e49d9$var$__publicField(this, "node", null);
        $e16fe9ae426e49d9$var$__publicField(this, "_unobserveCb", null);
        $e16fe9ae426e49d9$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $e16fe9ae426e49d9$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$e16fe9ae426e49d9$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $e16fe9ae426e49d9$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $bSJIT.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $e16fe9ae426e49d9$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $bSJIT.useState(null);
    const callback = $bSJIT.useRef(onChange);
    const [state, setState] = $bSJIT.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $bSJIT.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $e16fe9ae426e49d9$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $bSJIT.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});

parcelRegister("cX08X", function(module, exports) {
$parcel$export(module.exports, "default", () => $324abf1c8b4ba559$export$2e2bcd8739ae039);
const $324abf1c8b4ba559$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $324abf1c8b4ba559$var$result.mac = /Mac/.test(navigator.platform);
    $324abf1c8b4ba559$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $324abf1c8b4ba559$export$2e2bcd8739ae039 = $324abf1c8b4ba559$var$result;

});


parcelRegister("aYVZJ", function(module, exports) {
$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $fb7be545bd147d6f$export$4727956877b6f612);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cqB2C = parcelRequire("cqB2C");

var $6HPhi = parcelRequire("6HPhi");

var $1MKfC = parcelRequire("1MKfC");
const $fb7be545bd147d6f$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1MKfC.ToolTipContentWithKeymap), {
        description: formatMessage((0, $6HPhi.messages).deleteEmojiTooltip),
        keymap: (0, $cqB2C.backspace)
    });
};

});
parcelRegister("cqB2C", function(module, exports) {
$parcel$export(module.exports, "backspace", () => $043139e47bf031bc$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "arrowKeysMap", () => $043139e47bf031bc$export$8d734690d3a46118);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $ceqrK = parcelRequire("ceqrK");
const $043139e47bf031bc$export$1ea584ca7009bcc1 = (0, $ceqrK.makeKeyMapWithCommon)('Backspace', 'Backspace');
const $043139e47bf031bc$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};

});
parcelRegister("ceqrK", function(module, exports) {
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $b965762939b9ef4d$export$7e6b588cc98b34f1);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $er6wJ = parcelRequire("er6wJ");
function $b965762939b9ef4d$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return (0, $er6wJ.makeKeymap)(description, windows, mac, common);
}

});
parcelRegister("er6wJ", function(module, exports) {
$parcel$export(module.exports, "makeKeymap", () => $ce77555a1522e266$export$d8a7f422d8d42038);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ function $ce77555a1522e266$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}

});



parcelRegister("1MKfC", function(module, exports) {
$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $0836e46917900d31$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4C1qA = parcelRequire("4C1qA");
const $0836e46917900d31$var$tooltipShortcutStyle = null;
const $0836e46917900d31$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $4C1qA.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        className: (0, $9fU1q.default)([
            "_2rkofajl _bfhk1vck _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
        ])
    }, shortcut)) : null;
});

});
parcelRegister("4C1qA", function(module, exports) {
$parcel$export(module.exports, "formatShortcut", () => $62757755b79803cf$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $cX08X = parcelRequire("cX08X");

var $cqB2C = parcelRequire("cqB2C");
function $62757755b79803cf$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $cX08X.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = (0, $cqB2C.arrowKeysMap)[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $cX08X.default).mac ? '' : '+');
}

});



parcelRegister("a0KSx", function(module, exports) {
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $8a0c01a95686f669$export$d151e4941072147c);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $9Abbn = parcelRequire("9Abbn");

var $6HPhi = parcelRequire("6HPhi");
const $8a0c01a95686f669$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), {
        id: `screenreader-emoji-${emoji.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $6HPhi.messages).deleteEmojiTooltipForScreenreader,
        values: {
            shortName: emoji.shortName
        }
    }));
};

});

parcelRegister("3pBZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2078f9e615119e2$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hzFIQ = parcelRequire("hzFIQ");

var $cBVmT = parcelRequire("cBVmT");

var $9PwDt = parcelRequire("9PwDt");

var $g3vc1 = parcelRequire("g3vc1");

var $eNOYh = parcelRequire("eNOYh");

var $55FVI = parcelRequire("55FVI");
const $c2078f9e615119e2$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $c2078f9e615119e2$var$deleteButton = null;
const $c2078f9e615119e2$var$refreshedDeleteButton = null;
const $c2078f9e615119e2$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $c2078f9e615119e2$var$DeleteButton = (props)=>{
    const isRefreshEnabled = (0, $eNOYh.isRefreshEmojiPickerEnabled)();
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            isRefreshEnabled && "_154ir5cr _1xi2r5cr",
            (0, $55FVI.emojiDeleteButton)
        ]),
        "data-testid": $c2078f9e615119e2$export$28fc7374cf1206d4
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hzFIQ.default), {
        iconBefore: /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: $c2078f9e615119e2$var$styles.boxWrapperStyle
        }, isRefreshEnabled ? /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
            label: (0, $g3vc1.deleteEmojiLabel),
            color: "var(--ds-icon, #292A2E)",
            size: "medium"
        }) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
            label: (0, $g3vc1.deleteEmojiLabel),
            color: "var(--ds-text-subtle, #505258)",
            size: "small"
        })),
        onClick: props.onClick,
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        appearance: "subtle-link",
        spacing: "none",
        testId: "emoji-delete-button",
        tabIndex: -1
    }));
};
var $c2078f9e615119e2$export$2e2bcd8739ae039 = $c2078f9e615119e2$var$DeleteButton;

});
parcelRegister("eNOYh", function(module, exports) {
$parcel$export(module.exports, "isRefreshEmojiPickerEnabled", () => $e730d5d8bff9c10a$export$6e2c41f8d3a0d428);

var $evJGV = parcelRequire("evJGV");
const $e730d5d8bff9c10a$export$6e2c41f8d3a0d428 = ()=>{
    return (0, $evJGV.isTeamoji26RefreshEmojiPickerEnabled)();
};

});



parcelRegister("7JH3u", function(module, exports) {
$parcel$export(module.exports, "SpriteEmoji", () => $69b1b1e7bdd4e277$export$ef49ddbb198ce334);
/* SpriteEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5N1Y4 = parcelRequire("5N1Y4");

var $8MOlQ = parcelRequire("8MOlQ");

var $55FVI = parcelRequire("55FVI");
const $69b1b1e7bdd4e277$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $55FVI.emojiNodeStyles)} ${selected ? (0, $55FVI.commonSelectedStyles) : ''} ${selectOnHover ? (0, $55FVI.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) {
        if ((0, $5N1Y4.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) sizing = {
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
        else sizing = {
            width: `${fitToHeight}px`,
            height: `${fitToHeight}px`,
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
    }
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ $bSJIT.createElement((0, $8MOlQ.EmojiNodeWrapper), {
        ...props,
        type: "sprite",
        className: classes
    }, /*#__PURE__*/ $bSJIT.createElement("span", {
        className: (0, $55FVI.emojiSprite),
        style: style
    })));
};

});


parcelRegister("7hbMQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1658054e0df72a67$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5N1Y4 = parcelRequire("5N1Y4");

var $g3vc1 = parcelRequire("g3vc1");

var $8CP7F = parcelRequire("8CP7F");

var $55FVI = parcelRequire("55FVI");
const $1658054e0df72a67$var$placeholderContainer = null;
const $1658054e0df72a67$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $g3vc1.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = (0, $5N1Y4.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? {
        fill: 'f7f7f7',
        minWidth: `${0, $g3vc1.defaultDenseEmojiHeight}px`,
        minHeight: `${0, $g3vc1.defaultDenseEmojiHeight}px`
    } : {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-testid": (0, $8CP7F.emojiPlaceholderTestId)(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkofajl _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhk1l7x _s7n4nkob _o5721q9c _y3gn1h6o",
            [
                (0, $55FVI.placeholder),
                xcss
            ].join(' ')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $1658054e0df72a67$export$2e2bcd8739ae039 = $1658054e0df72a67$var$EmojiPlaceholder;

});
parcelRegister("8CP7F", function(module, exports) {
$parcel$export(module.exports, "emojiPlaceholderTestId", () => $e801db089ff8a487$export$73987987fac5266b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $e801db089ff8a487$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;

});



parcelRegister("45OtX", function(module, exports) {
$parcel$export(module.exports, "UfoErrorBoundary", () => $b8ffb99864dd18d0$export$5ef1c2550074a375);

var $bSJIT = parcelRequire("bSJIT");
class $b8ffb99864dd18d0$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});



//# sourceMappingURL=shared.7827ebed.js.map
